import { Button, ChevronDownIcon, DropdownMenu } from '@buffer-mono/popcorn'
import { useState } from 'react'
import styles from './SearchImages.module.css'

const ORIENTATIONS = [
  { id: 0, label: 'Any orientation', value: '' },
  { id: 1, label: 'Landscape', value: 'landscape' },
  { id: 2, label: 'Portrait', value: 'portrait' },
  { id: 3, label: 'Square', value: 'squarish' },
]

type OrientationDropdownMenuProps = {
  // @ts-expect-error TS(7051) FIXME: Parameter has a name but no type. Did you mean 'ar... Remove this comment to see the full error message
  onChangeOrientation: (string) => void
}

/**
 *  COMPONENT: ORIENTATION DROPDOWN MENU
 */
export const OrientationDropdownMenu = ({
  onChangeOrientation,
}: OrientationDropdownMenuProps) => {
  const [selectedOrientationLabel, setSelectedOrientationLabel] = useState(
    ORIENTATIONS[0].label,
  )

  // @ts-expect-error TS(7006) FIXME: Parameter 'orientation' implicitly has an 'any' ty... Remove this comment to see the full error message
  const handleOrientationChange = (orientation) => {
    onChangeOrientation(orientation.value)
    setSelectedOrientationLabel(orientation.label)
  }

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <Button variant="tertiary" className={styles.orientationTrigger}>
          {selectedOrientationLabel} <ChevronDownIcon />
        </Button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content align="start">
        {ORIENTATIONS.map((orientation) => (
          <DropdownMenu.CheckboxItem
            onSelect={() => handleOrientationChange(orientation)}
            key={orientation.id}
            checked={selectedOrientationLabel === orientation.label}
          >
            {orientation.label}
          </DropdownMenu.CheckboxItem>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  )
}
